export default {
  'openPlatform.common.refresh': '刷新',
  'openPlatform.common.viewAll': '查看全部',
  'openPlatform.common.details': '查看详情',
  'openPlatform.common.success': '成功',
  'openPlatform.common.failure': '失败',
  'openPlatform.common.enabled': '启用',
  'openPlatform.common.disabled': '停用',
  'openPlatform.common.cancel': '取消',
  'openPlatform.common.close': '关闭',
  'openPlatform.common.noData': '暂无',
  'openPlatform.workbench.title': '工作台',
  'openPlatform.workbench.loadFailed': '加载开放平台工作台失败',
  'openPlatform.workbench.manageApplications': '管理应用',
  'openPlatform.workbench.totalApplications': '应用总数',
  'openPlatform.workbench.activeApplications': '启用应用',
  'openPlatform.workbench.boundMembers': '绑定成员',
  'openPlatform.workbench.pendingBindings': '待处理绑定',
  'openPlatform.workbench.callsLast24Hours': '24 小时调用',
  'openPlatform.workbench.failedCallsLast24Hours': '24 小时失败',
  'openPlatform.workbench.pendingAlert': '当前有 {count} 个待处理绑定请求',
  'openPlatform.workbench.failedAlert':
    '过去 24 小时有 {count} 次 API 调用失败',
  'openPlatform.workbench.applicationOverview': '应用概览',
  'openPlatform.workbench.emptyApplications': '暂无企业对接',
  'openPlatform.workbench.boundMemberCount': '{count} 个绑定成员',
  'openPlatform.workbench.recentCalls': '最近 API 调用',
  'openPlatform.workbench.emptyCalls': '暂无 API 调用记录',
  'openPlatform.workbench.time': '时间',
  'openPlatform.workbench.application': '应用',
  'openPlatform.workbench.operation': '操作',
  'openPlatform.workbench.result': '结果',
  'openPlatform.workbench.tokenExchange': '获取 Token',
  'openPlatform.workbench.contextResolve': '解析上下文',
  'openPlatform.keys.title': '应用',
  'openPlatform.keys.loadFailed': '加载应用失败',
  'openPlatform.keys.permissionLoadFailed': '加载应用权限资源失败',
  'openPlatform.keys.selectPermission': '请选择要授权的权限',
  'openPlatform.keys.authorizeSuccess': '应用权限授权成功',
  'openPlatform.keys.authorizeFailed': '应用权限授权失败',
  'openPlatform.keys.updateSuccess': '修改应用成功',
  'openPlatform.keys.updateFailed': '修改应用失败',
  'openPlatform.keys.createFailed': '创建应用失败',
  'openPlatform.keys.create': '创建应用',
  'openPlatform.keys.empty': '暂无应用',
  'openPlatform.keys.edit': '编辑应用',
  'openPlatform.keys.rotateSecret': '重置 SecretKey',
  'openPlatform.keys.deleteConfirm': '删除后该应用将立即失效',
  'openPlatform.keys.delete': '删除应用',
  'openPlatform.keys.identifier': '应用标识符',
  'openPlatform.keys.tokenLifetime': 'Token 有效期',
  'openPlatform.keys.tokenLifetimeSeconds': '{seconds} 秒',
  'openPlatform.keys.permissions': '权限',
  'openPlatform.keys.permissionManagement': '权限管理',
  'openPlatform.keys.callbackUris': '成员绑定回调地址',
  'openPlatform.keys.applicationName': '应用名称',
  'openPlatform.keys.applicationNameRequired': '请输入应用名称',
  'openPlatform.keys.applicationNamePlaceholder': '例如：工单 SaaS',
  'openPlatform.keys.tokenLifetimeLabel': 'Token 有效期（秒）',
  'openPlatform.keys.callbackUrisRequired': '每行填写一个回调地址',
  'openPlatform.keys.credentialOnce': '应用凭证仅显示一次',
  'openPlatform.keys.saved': '我已保存',
  'openPlatform.keys.accessKey': '应用标识符 / AccessKey',
  'openPlatform.keys.authorize': '授权',
  'openPlatform.keys.authorizedPermissions': '已授权权限',
  'openPlatform.keys.noAuthorizedPermissions': '当前应用尚未授权任何权限',
  'openPlatform.keys.availableResources': '可授权资源',
  'openPlatform.keys.selectAll': '全选',
  'openPlatform.keys.noAvailableResources':
    '暂无可授权资源，请先在资源管理中定义',
  'openPlatform.detail.loadFailed': '加载应用详情失败',
  'openPlatform.detail.loading': '正在加载应用详情',
  'openPlatform.detail.updateSuccess': '应用信息已更新',
  'openPlatform.detail.updateFailed': '更新应用失败',
  'openPlatform.detail.enableSuccess': '应用已启用',
  'openPlatform.detail.disableSuccess': '应用已停用',
  'openPlatform.detail.enableFailed': '启用应用失败',
  'openPlatform.detail.disableFailed': '停用应用失败',
  'openPlatform.detail.rotateSuccess': 'SecretKey 已轮换',
  'openPlatform.detail.rotateFailed': 'SecretKey 轮换失败',
  'openPlatform.detail.permissionNoChange': '权限没有变化',
  'openPlatform.detail.permissionUpdateSuccess': '权限已更新',
  'openPlatform.detail.permissionUpdateFailed': '权限更新失败',
  'openPlatform.detail.unlinkSuccess': '绑定关系已解除',
  'openPlatform.detail.unlinkFailed': '解除绑定失败',
  'openPlatform.detail.notFound': '应用不存在',
  'openPlatform.detail.title': '应用详情',
  'openPlatform.detail.unnamedApplication': '未命名应用',
  'openPlatform.detail.secretStatus': 'SecretKey 状态',
  'openPlatform.detail.secretConfigured': '已配置',
  'openPlatform.detail.rotate': '轮换',
  'openPlatform.detail.tenant': '所属企业',
  'openPlatform.detail.creator': '创建管理员',
  'openPlatform.detail.createdAt': '创建时间',
  'openPlatform.detail.status': '应用状态',
  'openPlatform.detail.recentCall': '最近 API 调用',
  'openPlatform.detail.bindingCount': '已绑定成员数量',
  'openPlatform.detail.applicationId': '应用 ID',
  'openPlatform.detail.callbackSection': '回调地址',
  'openPlatform.detail.noCallbackUris': '未配置回调地址',
  'openPlatform.detail.savePermissions': '保存权限',
  'openPlatform.detail.bindings': '已绑定成员',
  'openPlatform.detail.member': '职阅成员',
  'openPlatform.detail.memberAccount': '成员账号',
  'openPlatform.detail.memberUuid': '成员 UUID',
  'openPlatform.detail.boundAt': '绑定时间',
  'openPlatform.detail.lastUsedAt': '最近使用时间',
  'openPlatform.detail.unlink': '解除绑定',
  'openPlatform.detail.unlinkConfirm': '解除后该绑定关系将失效',
  'openPlatform.detail.editTitle': '编辑应用',
  'openPlatform.detail.secretOnce': 'SecretKey 仅显示一次',
  'openPlatform.detail.secretMissing': '服务端未返回新的 SecretKey',
  'openPlatform.callLogs.title': 'API 调用日志',
  'openPlatform.callLogs.loadFailed': '加载调用日志失败',
  'openPlatform.callLogs.empty': '暂无 API 调用日志',
  'openPlatform.callLogs.callTime': '调用时间',
  'openPlatform.callLogs.operation': '操作',
  'openPlatform.callLogs.endpoint': '接口',
  'openPlatform.callLogs.applicationIdentifier': '应用标识符',
  'openPlatform.callLogs.memberUuid': '成员 UUID',
  'openPlatform.callLogs.requiredScope': '所需权限',
  'openPlatform.callLogs.statusCode': '状态码',
  'openPlatform.callLogs.duration': '耗时',
  'openPlatform.callLogs.result': '结果',
  'openPlatform.callLogs.enterpriseCall': '企业级调用',
  'openPlatform.callLogs.notSpecified': '未指定',
  'openPlatform.binding.invalidUrl': '绑定地址无效',
  'openPlatform.binding.expired': '绑定请求已过期或已完成',
  'openPlatform.binding.notFound': '绑定请求不存在',
  'openPlatform.binding.validateFailed': '验证绑定请求失败',
  'openPlatform.binding.validating': '正在验证绑定请求，请稍候...',
  'openPlatform.binding.returnToThirdParty': '返回第三方系统',
  'openPlatform.binding.back': '返回上一页',
  'openPlatform.binding.unavailable': '无法进行绑定',
  'openPlatform.binding.notLoggedInTitle': '未登录职阅账号',
  'openPlatform.binding.notLoggedInDescription':
    '您当前尚未登录职阅。绑定前，请先登录拥有该企业对接所属企业权限的职阅账号，以便完成对“{appName}”的绑定授权。',
  'openPlatform.binding.login': '登录职阅账号',
  'openPlatform.binding.cancelAndReturn': '取消并返回',
  'openPlatform.binding.bindingTitle': '申请绑定您的职阅账号',
  'openPlatform.binding.bindingDescription':
    '“{appName}”正在申请绑定您在当前企业下的职阅账号。绑定后，该应用可代表您在企业内执行已授权的业务代操作。',
  'openPlatform.binding.currentAccount': '当前登录账号',
  'openPlatform.binding.switchAccount': '切换账号',
  'openPlatform.binding.requestedScopes': '申请的接口权限范围：',
  'openPlatform.binding.expiresAt': '绑定请求有效期至 {expiresAt}',
  'openPlatform.binding.confirm': '确认绑定并授权',
  'openPlatform.binding.conflict': '当前职阅成员已绑定其他第三方用户',
  'openPlatform.binding.forbidden':
    '您当前登录的账号不属于该应用所属的职阅企业，无法完成绑定',
  'openPlatform.binding.confirmFailed': '确认绑定失败',
  'openPlatform.binding.unnamedApplication': '企业对接',
};
